"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DataExportProcessor", {
    enumerable: true,
    get: function() {
        return DataExportProcessor;
    }
});
const _stream = require("stream");
const _path = /*#__PURE__*/ _interop_require_default(require("path"));
const _iconvlite = /*#__PURE__*/ _interop_require_default(require("iconv-lite"));
const _common = require("@nestjs/common");
const _dayjs = /*#__PURE__*/ _interop_require_default(require("dayjs"));
const _utc = /*#__PURE__*/ _interop_require_default(require("dayjs/plugin/utc"));
const _timezone = /*#__PURE__*/ _interop_require_default(require("dayjs/plugin/timezone"));
const _helpers = require("~/modules/jobs/helpers");
const _exportservice = require("~/modules/jobs/jobs/export-import/export.service");
const _models = require("~/models");
const _catchError = require("~/helpers/catchError");
const _NcPluginMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/helpers/NcPluginMgrv2"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
_dayjs.default.extend(_utc.default);
_dayjs.default.extend(_timezone.default);
function getViewTitle(view) {
    return view == null ? void 0 : view.title;
}
let DataExportProcessor = class DataExportProcessor {
    async job(job) {
        const { context, options, modelId, viewId, user: _user, exportAs, ncSiteUrl } = job.data;
        if (exportAs !== 'csv' && exportAs !== 'json' && exportAs !== 'excel') _catchError.NcError.notImplemented(`Export as ${exportAs}`);
        const hrTime = (0, _helpers.initTime)();
        const model = await _models.Model.get(context, modelId);
        if (!model) _catchError.NcError.tableNotFound(modelId);
        const view = await _models.View.get(context, viewId);
        if (!view) _catchError.NcError.viewNotFound(viewId);
        // date time as containing folder YYYY-MM-DD/HH
        const dateFolder = (0, _dayjs.default)().format('YYYY-MM-DD/HH');
        const storageAdapter = await _NcPluginMgrv2.default.storageAdapter();
        const base = await _models.Base.get(context, model.base_id);
        const date = (0, _dayjs.default)().tz((options == null ? void 0 : options.filenameTimeZone) || 'Etc/UTC').format('YYYY-MM-DD_HH-mm');
        const filename = `${base.title} - ${model.title} (${getViewTitle(view)}) ${date}`;
        const fileExtension = exportAs === 'json' ? 'json' : exportAs === 'excel' ? 'xlsx' : 'csv';
        const destPath = `nc/uploads/data-export/${dateFolder}/${modelId}/${filename}.${fileExtension}`;
        let url = null;
        try {
            const dataStream = new _stream.Readable({
                read () {}
            });
            // Excel outputs binary data, so only set encoding for text-based formats
            if (exportAs !== 'excel') {
                dataStream.setEncoding('utf8');
            }
            const encodedStream = exportAs !== 'excel' && (options == null ? void 0 : options.encoding) && options.encoding !== 'utf-8' && _iconvlite.default.encodingExists(options.encoding) ? dataStream.pipe(_iconvlite.default.decodeStream('utf-8')).pipe(_iconvlite.default.encodeStream((options == null ? void 0 : options.encoding) || 'utf-8')) : dataStream;
            if (exportAs === 'csv' && (!(options == null ? void 0 : options.encoding) || options.encoding === 'utf-8') && options.includeByteOrderMark) {
                // Push UTF-8 BOM at the start (only for CSV text format)
                dataStream.push('\uFEFF');
            }
            let error = null;
            const uploadFilePromise = storageAdapter.fileCreateByStream(destPath, encodedStream).catch((e)=>{
                this.logger.error(e);
                error = e;
            });
            if (exportAs === 'json') {
                this.exportService.streamModelDataAsJson(context, {
                    dataStream,
                    baseId: model.base_id,
                    modelId: model.id,
                    viewId: view.id,
                    ncSiteUrl: ncSiteUrl,
                    includeCrossBaseColumns: true,
                    filterArrJson: options.filterArrJson,
                    sortArrJson: options.sortArrJson
                }).catch((e)=>{
                    this.logger.debug(e);
                    dataStream.push(null);
                    error = e;
                });
            } else if (exportAs === 'excel') {
                this.exportService.streamModelDataAsExcel(context, {
                    dataStream,
                    baseId: model.base_id,
                    modelId: model.id,
                    viewId: view.id,
                    ncSiteUrl: ncSiteUrl,
                    includeCrossBaseColumns: true,
                    filterArrJson: options.filterArrJson,
                    sortArrJson: options.sortArrJson
                }).catch((e)=>{
                    this.logger.debug(e);
                    dataStream.push(null);
                    error = e;
                });
            } else {
                this.exportService.streamModelDataAsCsv(context, {
                    dataStream,
                    linkStream: null,
                    baseId: model.base_id,
                    modelId: model.id,
                    viewId: view.id,
                    ncSiteUrl: ncSiteUrl,
                    delimiter: options == null ? void 0 : options.delimiter,
                    includeCrossBaseColumns: true,
                    filterArrJson: options.filterArrJson,
                    sortArrJson: options.sortArrJson
                }).catch((e)=>{
                    this.logger.debug(e);
                    dataStream.push(null);
                    error = e;
                });
            }
            url = await uploadFilePromise;
            if (error) {
                throw error;
            }
            // if url is not defined, it is local attachment
            const mimetype = exportAs === 'json' ? 'application/json' : exportAs === 'csv' ? 'text/csv' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            const filenameWithExt = `${filename}.${fileExtension}`;
            if (!url) {
                url = await _models.PresignedUrl.getSignedUrl({
                    pathOrUrl: _path.default.join(destPath.replace('nc/uploads/', '')),
                    filename: filenameWithExt,
                    expireSeconds: 3 * 60 * 60,
                    preview: false,
                    mimetype,
                    encoding: exportAs === 'excel' ? undefined : (options == null ? void 0 : options.encoding) || 'utf-8'
                });
            } else {
                url = await _models.PresignedUrl.getSignedUrl({
                    pathOrUrl: url,
                    filename: filenameWithExt,
                    expireSeconds: 3 * 60 * 60,
                    preview: false,
                    mimetype,
                    encoding: exportAs === 'excel' ? undefined : (options == null ? void 0 : options.encoding) || 'utf-8'
                });
            }
            (0, _helpers.elapsedTime)(hrTime, `exported data for model ${modelId} view ${viewId} as ${exportAs}`, 'exportData');
        } catch (e) {
            throw {
                data: {
                    extension_id: options == null ? void 0 : options.extension_id,
                    title: filename
                },
                message: e.message
            };
        }
        return {
            timestamp: new Date(),
            extension_id: options == null ? void 0 : options.extension_id,
            type: exportAs,
            title: filename,
            url
        };
    }
    constructor(exportService){
        this.exportService = exportService;
        this.logger = new _common.Logger(DataExportProcessor.name);
    }
};
DataExportProcessor = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _exportservice.ExportService === "undefined" ? Object : _exportservice.ExportService
    ])
], DataExportProcessor);
